import { Wrapper } from '@american-autonomy/ag-ui';

import PanelSection from 'components/PanelSection';

import { AMS_DECIMAL_PRECISION, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const AmsRecommendationSection: FunctionComponent<Props> = ({
    amsRecommendation,
    citationLinkText,
    className = '',
    describeAmsDriver,
    describeAmsRecommendation,
    driverLabel,
    testId = TEST_ID,
    title
}) => (
    <PanelSection
        className={`${styles.amsRecommendationSection} ${className}`}
        testId={testId}
        text={title}>
        <Wrapper className={styles.amsText}>
            {describeAmsRecommendation(
                amsRecommendation.lbPer100Gallons.toFixed(AMS_DECIMAL_PRECISION)
            )}
        </Wrapper>

        <Wrapper className={styles.amsDriver}>
            {describeAmsDriver(driverLabel(amsRecommendation.driverSource))}
        </Wrapper>

        <Wrapper className={styles.citationLink}>{citationLinkText}</Wrapper>
    </PanelSection>
);

export default AmsRecommendationSection;
